<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card v-if="errorException">
      <v-row
        align="center"
        class="pa-3 ma-3"
      >
        <v-icon
          small
          color="orange darken-3"
        >
          report_problem
        </v-icon>
        <span class="orange--text text--darken-3 align-center">{{
          errorException
        }}</span>
        <v-spacer />
        <IconBtn
          icons="close"
          :large="true"
          color="grey darken-4"
          @click="close"
        />
      </v-row>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="surname"
              label="Прізвище"
              :hide-details="true"
              :required="true"
              :error-messages="$v.surname.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="name"
              label="Ім'я"
              :hide-details="true"
              :required="true"
              :error-messages="$v.name.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="middlename"
              label="По батькові"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="phones"
              label="Контактні телефони"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="emails"
              label="Emails"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="position"
              label="Посада"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CompanySelect
              v-model="companies"
              :multiple-select="true"
              label="Компанії"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row v-show="agreements.length > 0">
          <v-col>
            <AgreementSelect
              v-model="agreements"
              :multiple-select="true"
              :disabled="true"
              label="Угоди"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as contactsApi from "../../backend/contactsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";
import CompanySelect from "../companies/CompanySelect.vue";
import AgreementSelect from "../agreements/AgreementSelect.vue";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
    CompanySelect,
    AgreementSelect,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    errorException: "",
    isChanged: false,
    name: "",
    surname: "",
    middlename: "",
    emails: "",
    phones: "",
    position: "",
    companies: [],
    agreements: [],
  }),
  validations: {
    name: {
      required,
    },
    surname: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.name.$invalid && this.$v.surname.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення контакту" : "Редагування контакту";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      contactsApi.getContact(this.id).then((entity) => {
        this.name = entity.name;
        this.surname = entity.surname;
        this.middlename = entity.middlename;
        this.emails = entity.emails;
        this.phones = entity.phones;
        this.position = entity.position;
        this.companies = entity.companies;
        this.agreements = entity.agreements;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;
      var companyIds = this.companies.map(e=>{
        return e.id;
      });

      var newEntity = {
        name: this.name,
        surname: this.surname,
        middlename: this.middlename,
        emails: this.emails.split(","),
        phones: this.phones.split(","),
        position: this.position,
        companies: companyIds,
      };

      if (this.id == 0) {
        await contactsApi
          .createContact(newEntity)
          .then(() => {
            this.$router.push({ path: "/crm-contacts" });
          });
      } else {
        await contactsApi.updateContact(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>